import React from "react";
import { Modal, Typography, Box, Backdrop, Button, Paper } from "@mui/material";
import { API, graphqlOperation } from "aws-amplify";
import { deleteItemmaster } from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
import { useThemes } from "../Theme/theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  outline: "none",
  borderRadius: "4px",
  '@media (min-width:600px)': {
    width: 'auto',
  },
  width: "90%",
};

const ConfirmCancel = ({ open, setOpen, path, ModalCloseEvent }) => {
  const { theme } = useThemes()

  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
    }
  };

  const CancelFun = () => {
    setOpen(false);
    if (path) {
      navigate("/" + path);
    } else {
      if (ModalCloseEvent) {
        ModalCloseEvent(false);
      } else {
        navigate("/");
      }
    }
  };

  return (
    <Modal
      id={open ? "cancelSave" : ""}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* <Fade in={open}> */}
      <Paper sx={style}>
        <Box
          sx={{
            borderRadius: "4px",
            padding: "15px",
            textAlign: "center",
            overflowY: { xs: "scroll", sm: "hidden" },
            ".MuiTableCell-root": {
              padding: "10px 10px",
              fontSize: "13px",
            },
          }}
        >
          <Typography sx={{ color: theme.palette.mode = "dark" ? "" : "rgb(60 60 60)", fontWeight: "bold" }}>
            Do you want to Exit?
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "15px",
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            No
          </Button>
          <Button
            color="info"
            onClick={CancelFun}
            variant="contained"
            sx={{ flex: 1, margin: "5px", fontSize: "12px" }}
          >
            Yes
          </Button>
        </Box>
      </Paper>
      {/* </Fade> */}
    </Modal>
  );
};

export default ConfirmCancel;
